import { defineMessages } from 'react-intl';

export default defineMessages({
    policyPeriodLabel: {
        id: 'gateway.directives.PolicyBillingSummaryDirective.policy-billing-summary.Summary',
        defaultMessage: 'Summary'
    },
    BillingSummaryTitel: {
        id: 'gateway.directives.PolicyBillingSummaryDirective.policy-billing-summary.Policy Period',
        defaultMessage: 'Policy Period'
    },
    taxesFeesLabel: {
        id: 'gateway.views.policy-detail.Taxes and Fees',
        defaultMessage: 'Taxes and Fees'
    },
    totalCostsLabel: {
        id: 'gateway.views.policy-detail.Total Costs',
        defaultMessage: 'Total Costs'
    },
    statusLabel: {
        id: 'gateway.views.policy-detail.Status',
        defaultMessage: 'Status'
    },
    delinquentLabel: {
        id: 'gateway.views.policy-detail.Delinquent',
        defaultMessage: 'Delinquent'
    },
    inGoodStandingLabel: {
        id: 'gateway.views.policy-detail.In Good Standing',
        defaultMessage: 'In Good Standing'
    },
    viewAccountBillingLabel: {
        id: 'gateway.directives.PolicyBillingSummaryDirective.policy-billing-summary.View Account Billing',
        defaultMessage: 'View Account Billing'
    },
    customerPaymentSummaryLabel: {
        id: 'gateway.views.policy-detail.Invoice Summary',
        defaultMessage: 'Invoice Summary'
    },
    totalPastDueLabel: {
        id: 'gateway.views.policy-detail.Total Past Due',
        defaultMessage: 'Total Past Due'
    },
    nextPaymentLabel: {
        id: 'gateway.views.policy-detail.Next Payment',
        defaultMessage: 'Next Payment'
    },
    totalDueLabel: {
        id: 'gateway.views.policy-detail.Total Due',
        defaultMessage: 'Total Due'
    },
    minimumDueLabel: {
        id: 'gateway.views.policy-detail.Minimum Due',
        defaultMessage: 'Minimum Due'
    },
    billingMethodLabel: {
        id: 'gateway.directives.PolicyBillingSummaryDirective.policy-billing-summary.Billing Method',
        defaultMessage: 'Billing Method'
    },
    paymentPlanTypeLabel: {
        id: 'gateway.directives.PolicyBillingSummaryDirective.policy-billing-summary.Payment Plan Type',
        defaultMessage: 'Payment Plan Type'
    },
    paymentPlanLabel: {
        id: 'gateway.directives.PolicyBillingSummaryDirective.policy-billing-summary.Payment Plan',
        defaultMessage: 'Payment Plan'
    },    
    paymentScheduleLabel: {
        id: 'gateway.directives.PolicyBillingSummaryDirective.policy-billing-summary.Payment Schedule',
        defaultMessage: 'Payment Schedule'
    },
    dueDateLabel: {
        id: 'gateway.directives.PolicyBillingSummaryDirective.policy-billing-summary.Due Date',
        defaultMessage: 'Due Date'
    },
    paidStatusLabel: {
        id: 'gateway.directives.PolicyBillingSummaryDirective.policy-billing-summary.Paid Status',
        defaultMessage: 'Paid Status'
    },
    PaidLabel: {
        id: 'gateway.directives.PolicyBillingSummaryDirective.policy-billing-summary.Paid',
        defaultMessage: 'Paid'
    },
    outstandingLabel: {
        id: 'gateway.directives.PolicyBillingSummaryDirective.policy-billing-summary.Outstanding',
        defaultMessage: 'Outstanding'
    },
    statementAmountLabel: {
        id: 'gateway.directives.PolicyBillingSummaryDirective.policy-billing-summary.Statement Amount',
        defaultMessage: 'Statement Amount'
    },
    loadingLabel: {
        id: 'gateway.directives.PolicyBillingSummaryDirective.policy-billing-summary.Loading',
        defaultMessage: 'Loading...'
    },
    noBillingDataLabel: {
        id: 'gateway.directives.PolicyBillingSummaryDirective.policy-billing-summary.No billing data for this policy, check back again in the next',
        defaultMessage: 'No billing data for this policy, check back again in the next 24 hour'
    },
    agencyBillDataLabel: {
        id: 'gateway.directives.PolicyBillingSummaryDirective.policy-billing-summary.No billing data for this policy',
        defaultMessage: 'No billing data for this policy'
    },
    viewPaymentMethodLabel: {
        id: 'gateway.directives.PolicyBillingSummaryDirective.policy-billing-summary.Payment Method',
        defaultMessage: 'Payment Method'
    },
    viewInvoiceDateLabel: {
        id: 'gateway.directives.PolicyBillingSummaryDirective.policy-billing-summary.Invoice Date',
        defaultMessage: 'Invoice Date'
    },    
    viewInvoiceDeliveryLabel: {
        id: 'gateway.directives.PolicyBillingSummaryDirective.policy-billing-summary.Invoice Delivery',
        defaultMessage: 'Invoice Delivery'
    },
    pastDue: {
        id: 'gateway.directives.PolicyBillingSummaryDirective.policy-billing-summary.Past Due',
        defaultMessage: 'Past Due'
    },
    invoiceAmountLabel: {
        id: 'gateway.directives.PolicyBillingSummaryDirective.policy-billing-summary.Invoice Amount',
        defaultMessage: 'Invoice Amount'
    }
});
